import '../plugins/AnchorLinkPlugin.js';

// mobile menu init
export default function initAnchors() {
	new SmoothScroll({
		anchorLinks: 'a.anchor-link:not([href="#"])',
		extraOffset: 0,
		animDuration: 0,
		activeClasses: 'link',
		wheelBehavior: 'none',
		extraOffset: extraOffset
	});

	function extraOffset(block, extraOffset) {
		let scrollTop = jQuery(window).scrollTop();
		let totalHeight = 0;
		let $header = jQuery('#header-portal');

		if (scrollTop > extraOffset) {
			totalHeight += $header.outerHeight();
		}

		if (window.matchMedia("(min-width: 992px)").matches) {
			jQuery('.nav-page-panel').each(function() {
				var $box = jQuery(this);

				totalHeight += $box.outerHeight();
			});
		}


		return totalHeight;
	}
}